/**
 * Tipo de armazenamento no Pedido de Saída (#MT-3902248 / RVD).
 * Refrigerado = flag do produto; demais com produto informado = Climatizado.
 */

/**
 * @param {object|null|undefined} product
 * @returns {'REFRIGERADO'|'CLIMATIZADO'|null}
 */
export function storageArmCodeFromProduct(product)
{
	if (!product)
		return null;
	const r = product.is_refrigerated;
	if (r === true || r === 1 || r === '1')
		return 'REFRIGERADO';
	return 'CLIMATIZADO';
}

/**
 * @param {'REFRIGERADO'|'CLIMATIZADO'|null|undefined} code
 * @returns {string}
 */
export function storageArmLabel(code)
{
	if (code === 'REFRIGERADO')
		return 'Refrigerado';
	if (code === 'CLIMATIZADO')
		return 'Climatizado';
	return '';
}

/**
 * @param {string|null|undefined} label
 * @returns {'REFRIGERADO'|'CLIMATIZADO'|null}
 */
export function storageArmCodeFromLabel(label)
{
	const t = String(label || '').trim().toUpperCase();
	if (t === 'REFRIGERADO')
		return 'REFRIGERADO';
	if (t === 'CLIMATIZADO')
		return 'CLIMATIZADO';
	return null;
}

/**
 * @param {Iterable<'REFRIGERADO'|'CLIMATIZADO'|null|undefined>} codes
 * @returns {boolean}
 */
export function hasMixedStorageArmCodes(codes)
{
	let hasRef = false;
	let hasClim = false;
	for (const code of codes || [])
	{
		if (code === 'REFRIGERADO')
			hasRef = true;
		else if (code === 'CLIMATIZADO')
			hasClim = true;
		if (hasRef && hasClim)
			return true;
	}
	return false;
}

/**
 * Coleta códigos Arm. de linhas com quantidade > 0 (lógica do banner).
 * @param {Array<{ quantity?: number|string, storage_arm?: string|null, arm?: string|null }>} lines
 * @returns {Array<'REFRIGERADO'|'CLIMATIZADO'>}
 */
export function collectStorageArmCodesFromLines(lines)
{
	const codes = [];
	for (const line of lines || [])
	{
		const rawQty = line?.quantity;
		const qty = Number(
			typeof rawQty === 'string'
				? String(rawQty).replace(/\./g, '').replace(',', '.')
				: rawQty,
		);
		if (!(qty > 0))
			continue;
		const code = storageArmCodeFromLabel(line?.storage_arm ?? line?.arm);
		if (code)
			codes.push(code);
	}
	return codes;
}

/**
 * Mistura a partir de itens do pedido + mapa produto (flag refrigerado).
 * @param {Array<{ product_id?: *, quantity?: * }>} items
 * @param {Map<number, object>|Record<number, object>} productsById
 * @returns {boolean}
 */
export function itemsHaveMixedStorageArm(items, productsById)
{
	const get = (pid) =>
	{
		if (!productsById)
			return null;
		if (typeof productsById.get === 'function')
			return productsById.get(pid);
		return productsById[pid] ?? productsById[String(pid)] ?? null;
	};
	const codes = [];
	for (const item of items || [])
	{
		const pid = Number(item?.product_id);
		const qty = Number(item?.quantity);
		if (!Number.isInteger(pid) || pid <= 0 || !(qty > 0))
			continue;
		codes.push(storageArmCodeFromProduct(get(pid) || { is_refrigerated: false }));
	}
	return hasMixedStorageArmCodes(codes);
}

export const STORAGE_ARM_BANNER_TEXT =
	'Atenção: este pedido mistura itens Climatizados e Refrigerados. Separe em pedidos distintos antes de gerar a saída, ou confirme o salvamento ciente da mistura.';
